import { QueryClient } from '@tanstack/react-query';

/** Phase 102: everything a payment's submission, approval or rejection
 * changes outside the screen it happened on — the Finance workspace
 * (dashboard, confirmations, ledger, student balances; not its static
 * lookups), the general Payments list and the sidebar/bell counts. */
export const invalidateFinanceData = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({
    predicate: (q) => {
      const key = String(q.queryKey[0]);
      return (
        (key.startsWith('finance-') && key !== 'finance-lookups') ||
        key === 'payments' ||
        key === 'notification-summary'
      );
    },
  });

/** Notification types that mean a payment's state just changed. */
export const PAYMENT_NOTIFICATION_TYPES = [
  'PAYMENT_VERIFICATION',
  'PAYMENT_APPROVED',
  'PAYMENT_REJECTED',
  'PAYMENT_EVIDENCE_REQUESTED',
  'PAYMENT_REMINDER',
] as const;
